{% block hueb_seo_conversion_detail %}

    <sw-page class="hueb-seo-conversion-detail">
        <template #smart-bar-actions>
            <sw-button-process
                    :isLoading="isLoading"
                    variant="primary"
                    :processSuccess="isLoading"
                    @click="onClickSave">
                {{ $t('hueb-seo-conversion.detail.saveButtonText') }}
            </sw-button-process>
        </template>

        <template #language-switch>
            <sw-language-switch #language-switch @on-change="onChangeLanguage"></sw-language-switch>
        </template>

        <template #content>
            <sw-card-view>
                <sw-card :isLoading="isLoading"
                         positionIdentifier="1">
                    <sw-tabs v-if="conversionData"
                            position-identifier="sw-media-modal-folder-settings"
                            :is-small="false"
                            default-item="404"
                    >
                        <template #default="{ active }">
                            {% block hueb_seo_conversion_tab_item_404 %}
                                <sw-tabs-item
                                        class="hueb_seo_conversion__404-tab"
                                        name="404"
                                        :active-tab="active"
                                        :native="true"
                                >
                                    {{ $tc('hueb-seo-conversion.conversion.tab404') }}
                                </sw-tabs-item>
                            {% endblock %}
                            {% block hueb_seo_conversion_tab_item_social_media %}
                                <sw-tabs-item
                                        class="hueb_seo_conversion___social_media-tab"
                                        name="socialMedia"
                                        :active-tab="active"
                                        :native="true"
                                >
                                    {{ $tc('hueb-seo-conversion.conversion.tabSocialmedia') }}
                                </sw-tabs-item>
                            {% endblock %}
                            {% block hueb_seo_conversion_tab_item_newsletter %}
                                <sw-tabs-item
                                        class="hueb_seo_conversion__newsletter-tab"
                                        name="newsletter"
                                        :active-tab="active"
                                        :native="true"
                                >
                                    {{ $tc('hueb-seo-conversion.conversion.tabNewsletter') }}
                                </sw-tabs-item>
                            {% endblock %}
                            {% block hueb_seo_conversion_tab_item_newsletter %}
                                <sw-tabs-item
                                        class="hueb_seo_conversion__header-tab"
                                        name="header"
                                        :active-tab="active"
                                        :native="true"
                                >
                                    {{ $tc('hueb-seo-conversion.conversion.tabHeader') }}
                                </sw-tabs-item>
                            {% endblock %}
                            {% block hueb_seo_conversion_tab_item_rich %}
                                <sw-tabs-item
                                        class="hueb_seo_conversion__rich-tab"
                                        name="rich"
                                        :active-tab="active"
                                        :native="true"
                                >
                                    {{ $tc('hueb-seo-conversion.conversion.tabRich') }}
                                </sw-tabs-item>
                            {% endblock %}
                        </template>
                        <template #content="{ active }">
                            {% block hueb_seo_conversion_tab_content_404 %}
                                <sw-container
                                        columns="1fr 1fr"
                                        gap="0px 16px"
                                        v-if="active === '404'"
                                >
                                    <sw-switch-field
                                            v-model:value="conversionData.huebErrPageStatus"
                                            no-margin-top
                                            :label="$t('hueb-seo-conversion.conversion.card.404.labelHeader')">
                                    </sw-switch-field>
                                    <sw-media-field
                                            v-model:value="conversionData.cpMediaId"
                                            :label="$t('hueb-seo-conversion.conversion.card.404.labelMedia')"
                                    >
                                    </sw-media-field>
                                </sw-container>
                                <mt-text-field
                                    v-if="active === '404' "
                                    v-model="conversionData.cpHeadline"
                                    :label="$tc('hueb-seo-conversion.conversion.card.404.labelHeader')"
                                    :placeholder="$tc('hueb-seo-conversion.conversion.card.404.placeholderHeader')">
                                </mt-text-field>
                            {% endblock %}
                            {% block hueb_seo_conversion_tab_content_social_media %}
                                <sw-container
                                        v-if="active === 'socialMedia'"
                                        class="hueb_seo_conversion__social_media-container"
                                        columns="1fr 1fr"
                                        gap="0px  12px"
                                >
                                    {% block hueb_seo_conversion_socialmedia_active %}
                                        <sw-switch-field
                                                v-model:value="conversionData.socialMediaFooterStatus"
                                                no-margin-top
                                                :helpText="$tc('hueb-seo-conversion.conversion.card.helpFontawsome')"
                                                :label="$t('hueb-seo-conversion.conversion.card.socialmedia.labelSocialmedia')">
                                        </sw-switch-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_colorText %}
                                        <sw-colorpicker
                                                v-model:value="conversionData.smfLogoTextColor"
                                                :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelColorText')"
                                                :helpText="$tc('hueb-seo-conversion.conversion.card.helpColor')">
                                        </sw-colorpicker>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_colorBg %}
                                        <sw-colorpicker
                                                v-model:value="conversionData.smfBackgroundColor"
                                                :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelColorBg')"
                                                :helpText="$tc('hueb-seo-conversion.conversion.card.helpColor')">
                                        </sw-colorpicker>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_text %}
                                        <mt-text-field
                                            v-model="conversionData.smfText"
                                            :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelText')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.socialmedia.placeholderText')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_facebook %}
                                        <mt-text-field
                                            v-model="conversionData.smfFacebookLink"
                                            :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelFacebook')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.socialmedia.placeholderFacebook')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_instagram %}
                                        <mt-text-field
                                            v-model="conversionData.smfInstagramLink"
                                            :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelInstagram')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.socialmedia.placeholderInstagram')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_twitter %}
                                        <mt-text-field
                                            v-model="conversionData.smfTwitterLink"
                                            :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelTwitter')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.socialmedia.placeholderTwitter')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_pinterest %}
                                        <mt-text-field
                                            v-model="conversionData.smfPinterestLink"
                                            :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelPinterest')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.socialmedia.placeholderPinterest')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_youtube %}
                                        <mt-text-field
                                            v-model="conversionData.smfYoutubeLink"
                                            :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelYoutube')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.socialmedia.placeholderYoutube')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_socialmedia_vimeo %}
                                        <mt-text-field
                                            v-model="conversionData.smfVimeoLink"
                                            :label="$tc('hueb-seo-conversion.conversion.card.socialmedia.labelVimeo')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.socialmedia.placeholderVimeo')">
                                        </mt-text-field>
                                    {% endblock %}
                                </sw-container>
                            {% endblock %}

                            {% block hueb_seo_conversion_tab_content_newsletter %}
                                <sw-container
                                        v-if="active === 'newsletter'"
                                        class="hueb_seo_conversion__newsletter-container"
                                        columns="1fr 1fr"
                                        gap="0px  12px"
                                >
                                    {% block hueb_seo_conversion_socialmedia_active %}
                                        <sw-switch-field
                                                v-model:value="conversionData.newsletterSubscriptionFooterStatus"
                                                no-margin-top
                                                :helpText="$tc('hueb-seo-conversion.conversion.card.helpNewsletter')"
                                                :label="$t('hueb-seo-conversion.conversion.card.newsletter.labelNewsletter')">
                                        </sw-switch-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_newsletter_colorText %}
                                        <sw-colorpicker
                                                v-model:value="conversionData.nsfTextColor"
                                                :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelColorText')"
                                                :helpText="$tc('hueb-seo-conversion.conversion.card.helpColor')"
                                        >
                                        </sw-colorpicker>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_newsletter_colorBg %}
                                        <sw-colorpicker
                                                v-model:value="conversionData.nsfBackgroundColor"
                                                :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelColorBg')"
                                                :helpText="$tc('hueb-seo-conversion.conversion.card.helpColor')"
                                        >
                                        </sw-colorpicker>
                                    {% endblock %}

                                    {% block hueb_seo_conversion_newsletter_headline %}
                                        <mt-text-field
                                            v-model="conversionData.nsfHeadline"
                                            :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelHeadline')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.newsletter.placeholderHeadline')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_newsletter_content %}
                                        <mt-textarea
                                            v-model="conversionData.nsfContent"
                                            :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelContent')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.newsletter.placeholderContent')">
                                        </mt-textarea>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_newsletter_button %}
                                        <mt-text-field
                                            v-model="conversionData.nsfButtonText"
                                            :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelButton')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.newsletter.placeholderButton')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_newsletter_arrowUp %}
                                        <mt-text-field
                                            v-model="conversionData.nsfUpperArrowText"
                                            :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelArrowUp')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.newsletter.placeholderArrowUp')">
                                        </mt-text-field>
                                    {% endblock %}
                                    {% block hueb_seo_conversion_newsletter_arrowDown %}
                                        <mt-text-field
                                            v-model="conversionData.nsfLowerArrowText"
                                            :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelArrowDown')"
                                            :placeholder="$tc('hueb-seo-conversion.conversion.card.newsletter.placeholderArrowDown')">
                                        </mt-text-field>
                                    {% endblock %}
                                </sw-container>
                            {% endblock %}

                            {% block hueb_seo_conversion_tab_content_header %}
                                <template v-if="active === 'header'">
                                    {% block hueb_seo_conversion_socialmedia_active %}
                                        <sw-switch-field v-model:value="conversionData.conversionHeaderStatus"
                                                         no-margin-top
                                                         :helpText="$tc('hueb-seo-conversion.conversion.card.helpFontawsome')"
                                                         :label="$t('hueb-seo-conversion.conversion.card.header.labelHeader')">
                                        </sw-switch-field>
                                    {% endblock %}
                                    <sw-container
                                            v-if="active === 'header'"
                                            class="hueb_seo_conversion__header-container"
                                            columns="1fr 1fr"
                                            gap="0px  12px"
                                    >
                                        {% block hueb_seo_conversion_header_colorText %}
                                            <sw-colorpicker
                                                    v-model:value="conversionData.cfTextColor"
                                                    :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelColorText')"
                                                    :helpText="$tc('hueb-seo-conversion.conversion.card.helpColor')"
                                            >
                                            </sw-colorpicker>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_colorBg %}
                                            <sw-colorpicker
                                                    v-model:value="conversionData.cfBackgroundColor"
                                                    :label="$tc('hueb-seo-conversion.conversion.card.newsletter.labelColorBg')"
                                                    :helpText="$tc('hueb-seo-conversion.conversion.card.helpColor')"
                                            >
                                            </sw-colorpicker>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId0 %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId0"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconId') + '0'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconId')">
                                            </mt-text-field>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId0Text %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId0Text"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconName') + '0'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconName')">
                                            </mt-text-field>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId1 %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId1"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconId') + '1'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconId')">
                                            </mt-text-field>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId1Text %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId1Text"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconName') + '1'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconName')">
                                            </mt-text-field>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId2 %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId2"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconId') + '2'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconId')">
                                            </mt-text-field>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId2Text %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId2Text"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconName') + '2'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconName')">
                                            </mt-text-field>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId3 %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId3"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconId') + '3'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconId')">
                                            </mt-text-field>
                                        {% endblock %}
                                        {% block hueb_seo_conversion_header_cfLogoId3Text %}
                                            <mt-text-field
                                                v-model="conversionData.cfLogoId3Text"
                                                :label="$tc('hueb-seo.conversion.card.header.labelIconName') + '3'"
                                                :placeholder="$tc('hueb-seo-conversion.conversion.card.header.placeholderIconName')">
                                            </mt-text-field>
                                        {% endblock %}

                                    </sw-container>
                                </template>
                            {% endblock %}

                            {% block hueb_seo_conversion_tab_content_rich %}
                                <template v-if="active === 'rich'">
                                    {% block hueb_seo_conversion_socialmedia_active %}
                                        <sw-switch-field v-model:value="conversionData.richSnippetsStatus"
                                                         no-margin-top
                                                         :helpText="$tc('hueb-seo-conversion.conversion.card.helpFontawsome')"
                                                         :label="$t('hueb-seo-conversion.conversion.card.rich.labelCheck')">
                                        </sw-switch-field>
                                    {% endblock %}
                                </template>
                            {% endblock %}
                        </template>
                    </sw-tabs>
                </sw-card>
            </sw-card-view>
        </template>

    </sw-page>
{% endblock %}
